export function promiseHelperAllSettled<T>(promises: Promise<T>[]) {
  return typeof Promise.allSettled === 'function' ? Promise.allSettled<T>(promises) : allSettledPolyfill<T>(promises);
}

function allSettledPolyfill<T>(promises: Promise<T>[]) {
  return Promise.all(promises.map((p) => (
    Promise.resolve(p).then(
      (value) => ({
        status: 'fulfilled',
        value
      }),
      (reason) => ({
        status: 'rejected',
        reason
      })
    )
  )));
}
